import { Component, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { BUSINESS_REG_APP_CONSTANT } from 'app/config/business-reg-app.constant';
import { LoaderService } from 'app/service/loader/loader.service';
import { TRCFundClasses } from 'app/shared/models/tRCFundClasses.model';
import { Router } from '@angular/router';
import { CustomAlertModalComponent } from 'app/shared/shared-component/custom-alert-modal/custom-alert-modal.component';
import { FormGroup } from '@angular/forms';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'jhi-eappreg-L288-measure',
  templateUrl: './eappreg-L288-measure.component.html',
  styleUrls: ['./eappreg-L288-measure.component.scss']
})
export class EappregL288MeasureComponent implements OnInit {

  eAppRegConstant: any;
  cModalTitle = "";
  cModalBody = "";
  @Input() fForm!: FormGroup;
  selectedAddr: any;
  loaderService:any
	parts : any;	
	year : any;	
	month : any;	
	day : any;	
	fromDateArr :any[] = [];	
	toDateArr :any[] = [];	
	yearString : any;	
	day1 : any;	
	date1 : any;
	totalMsr : any;
	totMeasures : any;
	ggr : any;
  trcFundClasses: TRCFundClasses[] = JSON.parse(sessionStorage.getItem("TRCFundClasses") ?? "");
  ngbModalOptions: NgbModalOptions = {
		backdrop: 'static',
		keyboard: false,
		size: 'lg',
		scrollable: false,
		centered: true
	};
  @Input() public trcFundClass: any
  constructor(public activeModal: NgbActiveModal,
    private router: Router,
	private modalService: NgbModal,
    private loader: LoaderService) {
      this.loaderService = this.loader;
  }

  ngOnInit(): void {
    this.eAppRegConstant = BUSINESS_REG_APP_CONSTANT;
	this.decrementFromYear();
	this.decrementToYear();
  }

  OK(): void {
    this.activeModal.close({"reason":"OK"})
  }

addMeasure(qfundClassGrid: TRCFundClasses, event: any): void {
	this.trcFundClasses = JSON.parse(sessionStorage.getItem("TRCFundClasses") ?? "");
		if(!qfundClassGrid.currentTaxPeriod){
		const fundclIndex = this.trcFundClasses.findIndex(obj => obj.revenue_type === qfundClassGrid.revenue_type && obj.taxPeriod === qfundClassGrid.taxPeriod)
		if (fundclIndex >= 0) {
			this.trcFundClasses[fundclIndex].measure = event.target.value
		} else {
			qfundClassGrid.measure = event.target.value;
			this.trcFundClasses.push(qfundClassGrid);
		}
		}
		//for Current tax period instead of adding a new row updating in existing row.
		else{
			const fundclIndex =this.trcFundClasses.findIndex(obj =>obj.revenue_type === qfundClassGrid.revenue_type && obj.taxPeriod==='')
			if (fundclIndex >= 0) {
			this.trcFundClasses[fundclIndex].measure = event.target.value
		} 
		}
		sessionStorage.setItem("TRCFundClasses", JSON.stringify(this.trcFundClasses));
	}
	
	//INC0754669 - Enhancement - PFA EappReg - Adding GGR
	calculateTotalMeasuress(qfundClassGrid: TRCFundClasses, event: any):any{
			
					const fundclIndex = this.trcFundClasses.findIndex(obj => obj.revenue_type === qfundClassGrid.revenue_type && obj.taxPeriod === '')
					const str = qfundClassGrid.taxPeriod;
					const lastLetter = str[str.length - 1];
					if (fundclIndex >= 0) {
						if (lastLetter === 'A' && qfundClassGrid.currentTaxPeriod ){
							this.totalMsr = Number(sessionStorage.getItem("totalMsr"));
							this.totalMsr -= Number(this.trcFundClasses[fundclIndex].measure);
							this.totalMsr += Number(event.target.value);
							sessionStorage.setItem("totalMsr", this.totalMsr);
							
				}
				}
				
				this.totMeasures=Number(sessionStorage.getItem("totalMsr"));
				this.ggr= sessionStorage.getItem("GGR");
			if(this.ggr!==''){
				if((Number(this.ggr) < this.totMeasures) ){
				
					this.fForm.controls.globalGrossReceipts.setErrors({ validateGgrErr: true });
					this.errorGgrMeasures();
  					} 
				}
			else {
    			this.fForm.controls.globalGrossReceipts.setErrors(null);
  				}
		
			}
			
			errorGgrMeasures(): void {
    

      const title = "Confirmation"
	const body = "The Total Gross Receipts cannot be less than the sum of all Measures(Basis for Tax) entered."
      const modalRef = this.modalService.open(CustomAlertModalComponent, this.ngbModalOptions)
      modalRef.componentInstance.cModalTitle = title
      modalRef.componentInstance.cModalBody = body
      modalRef.result.then((userResponse) => {
        if (userResponse === "OK") {
          this.router.navigate(['/eappreg_app']);
        }
      });
    }
	
	/*Added function to show date from and date to year one year less than tax-period*/
	decrementFromYear() : any{	
		
		for (let j = 0; j < this.trcFundClass.length; j++) {
			const parts = this.trcFundClass[j].dateFrom.split("-");	
		
			this.year =Number(parts[0])-1	
			const month = Number(parts[1]);	
			const day= Number(parts[2]);	
		
			
			this.trcFundClass[j].dateFrom = new Date(this.year, month-1, day);
			
		}	
	}	
		
	decrementToYear() : any{	
		
		for (let j = 0; j < this.trcFundClass.length; j++) {
			
			const parts = this.trcFundClass[j].dateTo.split("-");	
		
			this.year =Number(parts[0])-1	
			const month = Number(parts[1]);	
			const day= Number(parts[2]);	
		
			this.trcFundClass[j].dateTo = new Date(this.year, month-1, day);
		
		}	
	}
}
